
import './App.scss';
import RootLayout from './components/RootLayout';












function App() {
  return (
    <div className="App">
      <RootLayout />
     


    </div>
  );
}

export default App;
